/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { Check, ChevronsUpDown } from "lucide-react";

import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

import { Fragment, useEffect, useMemo, useState } from "react";
import { GenericType } from "@/types";
export const MultiSelectWithSearchV3 = ({
  placeholder,
  value,
  onChange,
  defaultValue,
  options,
  bindValue,
  bindLabel,
  className,
  onBlur,
  noLimit,
  disabled,
}: GenericType) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      if (defaultValue) {
        onChange(defaultValue);
      }
    }, 100);
  }, [defaultValue]);

  const onChangeHandle = (prop: any) => {
    if (Array.isArray(value)) {
      const checkIsExist = value?.find((item: any) => item === prop);
      if (checkIsExist) {
        const updatedList = value?.filter((item: any) => item !== prop);
        onChange(updatedList);
      } else {
        const updatedList = [...value, prop];
        onChange(updatedList);
      }
    } else {
      onChange([prop]);
    }
  };

  const checkIsActive = (prop: any) => {
    if (Array.isArray(value)) {
      const result = value.find((item) => item?.toLowerCase() === prop);
      return result ? true : false;
    }
    return false;
  };

  const displayLabel = useMemo(() => {
    const tempList: any = [];
    options.map((item: any) => {
      if (value?.includes(item?.[bindValue])) {
        tempList.push(item?.[bindLabel]);
      }
    });
    return tempList;
  }, [value]);

  return (
    <Popover open={open} onOpenChange={setOpen} modal={true}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          disabled={disabled}
          className={cn(
            "w-full justify-between capitalize",
            className,
            noLimit ? "px-2 h-auto min-h-[40px]" : "",
          )}
        >
          <span className={cn(noLimit ? "flex flex-wrap gap-2" : "truncate")}>
            {displayLabel?.[0] ? (
              <Fragment>
                {noLimit ? (
                  value?.map((cItem: string) => {
                    return (
                      <span
                        className="pr-2 bg-slate-50 text-slate-600 border-slate-200 border rounded-md text-xs mr-1 px-2 py-1"
                        key={cItem}
                      >
                        {cItem}
                      </span>
                    );
                  })
                ) : (
                  <>
                    {displayLabel?.[0]}
                    {displayLabel.length > 1 ? (
                      <span className="pl-2">
                        (+ {displayLabel.length - 1}){" "}
                      </span>
                    ) : null}
                  </>
                )}
              </Fragment>
            ) : (
              <span className="opacity-65">{placeholder}</span>
            )}
          </span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>

      <PopoverContent
        className="w-full p-0  z-[9999]"
        align="start"
        onBlur={onBlur}
      >
        <Command>
          <CommandInput placeholder="Search..." className="h-9" />
          <div className="flex items-center justify-between px-2 py-1 border-b">
            <Button
              variant="ghost"
              size="sm"
              className="h-auto px-2 py-1 text-xs"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                const allValues = options?.map((opt: any) => opt?.[bindValue]) || [];
                onChange(allValues);
              }}
            >
              Select All
            </Button>
            <Button
              variant="ghost"
              size="sm"
              className="h-auto px-2 py-1 text-xs text-muted-foreground"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onChange([]);
              }}
            >
              Cancel
            </Button>
          </div>
          <CommandList>
            <CommandEmpty>No Item found.</CommandEmpty>
            <CommandGroup>
              {options?.map((option: GenericType, index: number) => (
                <CommandItem
                  key={option?.[bindValue] || index}
                  value={option?.[bindLabel]}
                  onSelect={() => {
                    onChangeHandle(option?.[bindValue]);
                  }}
                >
                  {option?.[bindLabel]}
                  <Check
                    className={cn(
                      "ml-auto",
                      checkIsActive(option?.[bindValue]?.toLowerCase())
                        ? "opacity-100"
                        : "opacity-0",
                    )}
                  />
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
